import { motion } from "framer-motion";

const OPTIONS = [
  { id: "daily", label: "Today" },
  { id: "explore", label: "Explore" },
];

export const ModeSwitch = ({ mode, onChange }) => {
  return (
    <div
      role="tablist"
      data-testid="mode-switch"
      className="inline-flex items-center rounded-full border border-[#E5E1D8] bg-[#F5F3ED]/70 backdrop-blur-sm p-0.5"
    >
      {OPTIONS.map((opt) => {
        const active = mode === opt.id;
        return (
          <motion.button
            key={opt.id}
            role="tab"
            aria-selected={active}
            data-testid={`mode-${opt.id}`}
            onClick={(e) => {
              e.stopPropagation();
              onChange(opt.id);
            }}
            whileTap={{ scale: 0.95 }}
            className={[
              "font-ui rounded-full px-4 py-1.5 text-[10px] md:text-xs uppercase tracking-[0.18em] transition-colors duration-300",
              active
                ? "bg-[#4A5D4E] text-[#F5F3ED]"
                : "text-[#6A6661] hover:text-[#2C2A28]",
            ].join(" ")}
          >
            {opt.label}
          </motion.button>
        );
      })}
    </div>
  );
};
